<template>
    <button 
      class="bg bg-success text-center py-2 text-white border-0 font-weight-bold"
      type="button"
      @click="openWhatsApp" 
      style="cursor: pointer;">
      <i class="fab fa-whatsapp pr-1"></i> Contactar por WhatsApp
    </button>
  </template>
  
  <script>
  export default {
    props: ['celular', 'producto'],
    methods: {
      openWhatsApp() {
        const phone = '+56'+this.celular;
        const message = encodeURIComponent('Hola, estoy interesado en tu publicación: ' + this.producto);
        const whatsappUrl = `https://wa.me/${phone}?text=${message}`;
        window.open(whatsappUrl, '_blank');
      }
    }
  };
  </script>
  